import { useTranslation } from 'react-i18next';
import { TenantOrganizationType } from '../api/account/accountApiTypes';

// Order shown in the onboarding + legal-notice selects.
export const ORGANIZATION_TYPES: TenantOrganizationType[] = [
    'company',
    'municipality',
    'association',
];

// Shared SelectField props so the option list + labels stay in one place
// across the signup form and the account legal-notice form.
export const useOrganizationTypeOptions = () => {
    const { t } = useTranslation();
    const optionLabels: Record<string, string> = Object.fromEntries(
        ORGANIZATION_TYPES.map((type) => [type, t(`organization_type.${type}`) as string]),
    );
    return { options: ORGANIZATION_TYPES, optionLabels };
};
